export default {
      id: "notifications__overspeeding_gis-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__overspeeding_gis",
      toString: function () {
        return this.url;
      }
    }